import React, { useRef, useState } from "react";
import { Carousel, CarouselProps } from "antd";
import { CarouselRef } from "antd/es/carousel";

import styles from "./index.pc.module.scss";
import classNames from "classnames";

interface CarouselCustomProps extends CarouselProps {
  children: React.ReactNode;
  showControls?: boolean;
}

export const CarouselCustom = (props: CarouselCustomProps) => {
  const { children, showControls, beforeChange, ...rest } = props;
  const carouselRef = useRef<CarouselRef>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const next = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const prev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  const goTo = (index: number) => {
    if (carouselRef.current) {
      carouselRef.current.goTo(index);
    }
  };

  const dots = React.Children.toArray(children);

  return (
    <div className={styles.carousel}>
      <Carousel
        {...rest}
        arrows={false}
        dots={false}
        ref={carouselRef}
        beforeChange={(from, to) => {
          if (beforeChange) {
            beforeChange(from, to);
          }
          setActiveIndex(to);
        }}
      >
        {children}
      </Carousel>

      {showControls ? (
        <div className={classNames(styles.controls, "yolo-custom-slick-controls")}>
          <ul className={classNames(styles.dots, "yolo-custom-slick-dots")}>
            {dots.map((_, index) => (
              <li
                key={index}
                className={classNames(styles.dot, {
                  "yolo-custom-slick-dot": true,
                  [styles.active]: activeIndex === index
                })}
                onClick={() => goTo(index)}
              ></li>
            ))}
          </ul>
          <div className={classNames(styles.arrows, "yolo-custom-slick-arrows")}>
            <span className={classNames(styles.arrow, "yolo-custom-slick-arrow")} onClick={prev}>
              <ArrowIcon />
            </span>
            <span
              className={classNames(styles.arrow, styles.right, "yolo-custom-slick-arrow")}
              onClick={next}
            >
              <ArrowIcon />
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={8} height={13} fill='none' {...props}>
    <path
      fill='#fff'
      fillOpacity={0.7}
      fillRule='evenodd'
      d='m6.257 12.5 1.487-1.487L3.231 6.5l4.513-4.513L6.257.5l-6 6 6 6Z'
      clipRule='evenodd'
    />
  </svg>
);
